/**
 * @generated SignedSource<<27a6b23e699b1010b2591b49f8a2e6f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentsCollection_AttachmentsCollectionFragment$data = {
  readonly attachmentsV2: ReadonlyArray<{
    readonly file?: {
      readonly name: string;
      readonly url: string | null;
    } | null;
    readonly title: string | null;
  }>;
  readonly indexPath: ReadonlyArray<number>;
  readonly " $fragmentType": "AttachmentsCollection_AttachmentsCollectionFragment";
};
export type AttachmentsCollection_AttachmentsCollectionFragment$key = {
  readonly " $data"?: AttachmentsCollection_AttachmentsCollectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentsCollection_AttachmentsCollectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentsCollection_AttachmentsCollectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "indexPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "attachmentsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "file",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "FileAttachment",
          "abstractKey": "__isFileAttachment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityV2",
  "abstractKey": null
};

(node as any).hash = "3e99c97fc3d10fa4a77397115153c5c6";

export default node;
